import { ev } from "../../lib/everythingCopy";

export function NoteForm({ title, text, saving, onTitleChange, onTextChange, onSave }) {
  return (
    <section className="mb-5 max-w-xs">
      <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-400 dark:text-zinc-500 mb-1.5">
        {ev.noteTitle}
      </p>
      <input
        type="text"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        placeholder={ev.noteTitlePlaceholder}
        className="w-full rounded-lg border border-zinc-200 dark:border-zinc-700 bg-white/60 dark:bg-zinc-900/60 px-2.5 py-1.5 text-xs font-medium text-zinc-800 dark:text-zinc-100 placeholder:text-zinc-400 dark:placeholder:text-zinc-600 focus:outline-none focus:ring-2 focus:ring-zinc-300 dark:focus:ring-zinc-600"
      />
      <textarea
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder={ev.noteTextPlaceholder}
        rows={2}
        className="mt-1.5 w-full rounded-lg border border-zinc-200 dark:border-zinc-700 bg-white/60 dark:bg-zinc-900/60 px-2.5 py-1.5 text-xs text-zinc-700 dark:text-zinc-200 placeholder:text-zinc-400 dark:placeholder:text-zinc-600 focus:outline-none focus:ring-2 focus:ring-zinc-300 dark:focus:ring-zinc-600 resize-none leading-snug"
        onKeyDown={(e) => {
          if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) onSave();
        }}
      />
      <button
        type="button"
        onClick={onSave}
        disabled={saving || !text.trim()}
        className="mt-2 inline-flex items-center justify-center px-3 py-1.5 rounded-full bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 text-xs font-medium hover:bg-zinc-800 dark:hover:bg-zinc-200 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      >
        {saving ? ev.savingNote : ev.saveNote}
      </button>
    </section>
  );
}
